/**
 * MapSceneEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { MapEntity } from "../MapEntity";
import { BugEntity } from "../BugEntity";
import { MapSceneEntity } from "../MapSceneEntity";
declare global {
    interface EntityTypeMap {
        MapScene: MapSceneEntity;
    }
}
export abstract class MapSceneGeneratedEntity extends BaseEntity {
    public abstract mapSceneId: string;
    public abstract templateId: string | null;
    public abstract viewpointLocationX: number;
    public abstract viewpointLocationY: number;
    public abstract viewpointLocationZ: number;
    public abstract viewpointDirectionX: number;
    public abstract viewpointDirectionY: number;
    public abstract viewpointDirectionZ: number;
    public abstract objectBimGuid: string | null;
    public abstract objectName: string | null;
    public abstract map: MapEntity;
    public abstract bug: BugEntity;
}
